import moment from 'moment';

export const getSelectedDate = (day?: string | Date, time?: string): moment.Moment => {
    const [hours, minutes] = time?.split(':') || [0, 0];
    const newDate = moment(day).add(hours, 'h').add(minutes, 'minute');

    return newDate;
};
